import type { AppLocale, Messages } from "../types";
import { azOverrides } from "./az";
import { enOverrides } from "./en";
import { messages as ru } from "./ru";

function mergeLocale(
  overrides: Partial<Record<keyof typeof ru, string>>,
): Messages {
  return { ...ru, ...overrides };
}

export const messagesByLocale: Record<AppLocale, Messages> = {
  ru,
  en: mergeLocale(enOverrides),
  az: mergeLocale(azOverrides),
};
